import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import * as timeLogsApi from '@/api/timeLogs'

export function useSkippedPriorityIds(weekStart: string): Set<string> | undefined {
  const { data } = useQuery({
    queryKey: ['timeLogs', 'skipped', weekStart],
    queryFn: () => timeLogsApi.fetchSkippedPriorityIds(weekStart),
  })
  return data ? new Set(data) : undefined
}

function invalidateTimeLogs(qc: ReturnType<typeof useQueryClient>) {
  void qc.invalidateQueries({ queryKey: ['timeLogs'] })
  void qc.invalidateQueries({ queryKey: ['allocation'] })
}

export function useSkipPriorityWeek() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ priorityId, weekStart }: { priorityId: string; weekStart: string }) =>
      timeLogsApi.skipPriorityWeek(priorityId, weekStart),
    onSuccess: () => invalidateTimeLogs(qc),
  })
}

export function useUnskipPriorityWeek() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ priorityId, weekStart }: { priorityId: string; weekStart: string }) =>
      timeLogsApi.unskipPriorityWeek(priorityId, weekStart),
    onSuccess: () => invalidateTimeLogs(qc),
  })
}
